import React, { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { IFormRadioInputProps } from './types';

export const FormRadioInput: FunctionComponent<IFormRadioInputProps> = ({ name, options }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={options[0]?.value ?? ''}
      render={(controllerProps) => (
        <>
          {options.map((opt) => (
            <React.Fragment key={opt.id}>
              <input
                type="radio"
                id={opt.id}
                value={String(opt.value)}
                name={name}
                onClick={() => controllerProps.onChange(opt.value)}
                defaultChecked={controllerProps.value === opt.value}
              />
              <label htmlFor={opt.id} className="mr-2" style={{ marginBottom: '13px', position: 'relative' }}>
                {opt.label}
              </label>
            </React.Fragment>
          ))}
        </>
      )}
    />
  );
};
